import React from "react";

// Flat array default structure
export const defaultrightscategories = [
  {
    category: "Sexual Harassment",
    current_filed: "",
    current_pending: "",
    current_remarks: "",
    previous_filed: "",
    previous_pending: "",
    previous_remarks: "",
  },
  {
    category: "Discrimination at work place",
    current_filed: "",
    current_pending: "",
    current_remarks: "",
    previous_filed: "",
    previous_pending: "",
    previous_remarks: "",
  },
  {
    category: "Child Labor",
    current_filed: "",
    current_pending: "",
    current_remarks: "",
    previous_filed: "",
    previous_pending: "",
    previous_remarks: "",
  },
  {
    category: "Forced Labor/ Involuntary Labor",
    current_filed: "",
    current_pending: "",
    current_remarks: "",
    previous_filed: "",
    previous_pending: "",
    previous_remarks: "",
  },
  {
    category: "Wages",
    current_filed: "",
    current_pending: "",
    current_remarks: "",
    previous_filed: "",
    previous_pending: "",
    previous_remarks: "",
  },
  {
    category: "Other human rights related issues",
    current_filed: "",
    current_pending: "",
    current_remarks: "",
    previous_filed: "",
    previous_pending: "",
    previous_remarks: "",
  },
];

const HumanRightsComplaintsTable = ({
  humanrightsdata,
  setHumanrightsData,
}) => {
  const rows =
    Array.isArray(humanrightsdata) && humanrightsdata.length > 0
      ? humanrightsdata
      : defaultrightscategories;

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setHumanrightsData(updated);
  };

  return (
    <div
      style={{
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE" }}>
            <th rowSpan={2} style={cellHeader}>
              Category
            </th>
            <th colSpan={3} style={cellHeader}>
              Current FY
            </th>
            <th colSpan={3} style={cellHeader}>
              Previous FY
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE" }}>
            <th style={cellHeader}>Filed during the year</th>
            <th style={cellHeader}>
              Pending resolution at the end of the year
            </th>
            <th style={cellHeader}>Remarks</th>
            <th style={cellHeader}>Filed during the year</th>
            <th style={cellHeader}>
              Pending resolution at the end of the year
            </th>
            <th style={cellHeader}>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.category}>
              <td style={{ ...cell, fontWeight: "bold", textAlign: "left" }}>
                {row.category}
              </td>

              <td style={cell}>
                <input
                  type="text"
                  value={row.current_filed}
                  onChange={(e) =>
                    handleChange(index, "current_filed", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="Details"
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  value={row.current_pending}
                  onChange={(e) =>
                    handleChange(index, "current_pending", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="Details"
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  value={row.current_remarks}
                  onChange={(e) =>
                    handleChange(index, "current_remarks", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="Details"
                />
              </td>

              <td style={cell}>
                <input
                  type="text"
                  value={row.previous_filed}
                  onChange={(e) =>
                    handleChange(index, "previous_filed", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="Details"
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  value={row.previous_pending}
                  onChange={(e) =>
                    handleChange(index, "previous_pending", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="Details"
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  value={row.previous_remarks}
                  onChange={(e) =>
                    handleChange(index, "previous_remarks", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="Details"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const cellHeader = {
  border: "1px solid #000",
  padding: "10px",
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "#D3C9CE",
};

const cell = {
  border: "1px solid #ccc",
  padding: "10px",
  textAlign: "center",
};

const inputStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid gray",
  fontSize: "14px",
};

export default HumanRightsComplaintsTable;
